<template>
  <BaseDataIterator ref="dataList" :service="fetchData">
    <template #default="{ data }">
      <BaseDataTable :data="data">
        <template #header>
          <CampaignListHeader />
        </template>

        <template #default="{ item }">
          <CampaignListItem :ga-campaign="item" />
        </template>
      </BaseDataTable>
    </template>
  </BaseDataIterator>
</template>

<script>
import { googleAdsCampaignsClient } from '@/api/clients/admin';
import CampaignListHeader from './CampaignListHeader.vue';
import CampaignListItem from './CampaignListItem.vue';

export default {
  components: {
    CampaignListHeader,
    CampaignListItem,
  },
  data() {
    return {
      //
    };
  },
  methods: {
    async fetchData(params = {}) {
      try {
        const response = await googleAdsCampaignsClient.list({
          ...params,
          include: 'gaCustomer,lifetimeReport,campaignsCount',
        });

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
